import * as React from 'react';
import { FormContext } from '../FormContext';
import { Buttons } from '../Buttons';
import { Loader } from '@wix/design-system';
import { useTranslation } from 'react-i18next';
import { ActionButton } from '@wix/package-picker-components';

export const FormButtons: React.FC = () => {
  const { isSubmitting } = React.useContext(FormContext);
  const { t } = useTranslation();

  return (
    <Buttons>
      <ActionButton dataHook='form-submit-button' type='submit'>
        {isSubmitting ? (
          <Loader dataHook='submit-loader' size='tiny' />
        ) : (
          t('premium_plan.business_enterprise.request_call_form.submit_button')
        )}
      </ActionButton>
    </Buttons>
  );
};
